import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from 'src/app/core/services/account.service';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';

@Component({
  selector: 'app-account-accept-adoption',
  templateUrl: './account-accept-adoption.component.html',
  styleUrls: ['./account-accept-adoption.component.scss']
})
export class AccountAcceptAdoptionComponent implements OnInit {
  token: string;
  businessName: string;
  serviceTerm: string;
  userForm: FormGroup;
  agreement: boolean;
  get f() { return this.userForm.controls; }
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private accountService: AccountService,
    private toastService: HotToastService) { }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.token = params.p;
      });
    this.accountService.adoptionRequestInformation(encodeURIComponent(this.token)).subscribe(result => {
      this.businessName = result.content;
    },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.toastService.warning("This request does not belong to the logged in account. Please ensure you are logged into the correct account.");
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
    this.accountService.getAdoptionServiceTerm().subscribe(result => {
      //remove  inline styling from serviceTerm
      this.serviceTerm = (result.content).replace(new RegExp('style="(.*?)"', 'g'), "");
    }, (error: HttpErrorResponse) => {
      this.toastService.warning(error.message);
    });
    this.userForm = this.formBuilder.group({
      agreement: [false, Validators.requiredTrue],
    });
  }

  onSubmit() {
    if (this.userForm.controls.agreement.value) {
      this.accountService.acceptAccountAdoption(encodeURIComponent(this.token)).subscribe(() => {
        this.router.navigate(['account/account-adoption-complete'], { queryParams: { businessName: this.businessName } });
      }, (error: HttpErrorResponse) => {
        this.toastService.warning(error.message);
      });
    } else {
      this.toastService.warning("Must agree to the terms and conditions to accept account link request");
    }
  }
}
